module.exports = __webpack_public_path__ + "img/plant_3_mobile_small.53ca3a02.webp";